module.exports = __webpack_public_path__ + "img/room12.291eba74.gif";